export function localTextIssue(value, kind, required) {
  if (new TextEncoder().encode(value).length > 256 * 1024) return '内容超过 256 KiB，完整输入已保留，请缩短后再保存。'
  const length = Array.from(value).length
  if (kind === 'material' && (length < 2 || length > 300)) return `图片说明请填写 2～300 个字，当前 ${length} 字；完整输入已保留。`
  return required && !value.trim() ? '请填写有效正文。' : ''
}

export async function convertedPaste(clipboard, inspect) {
  const { value, start, end, text, html } = clipboard
  const checked = await inspect({ text, html, kind: 'profile' })
  if (checked.conversion_failed || !checked.pasted_source) throw new Error(checked.issues?.[0] || '排版识别未完成，原输入已保留，请重试。')
  const prefix = value.slice(0, start), suffix = value.slice(end)
  const result = prefix + checked.text + suffix
  const hash = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(result))
  const text_sha256 = Array.from(new Uint8Array(hash), byte => byte.toString(16).padStart(2, '0')).join('')
  return { text: result, source: { ...checked.pasted_source, prefix, suffix, text_sha256, bound_text: result } }
}
